var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('h3',[_vm._v("OOPS! PAGE NOT FOUND")]),_c('div',{staticClass:"not-found-container1"},[_c('h1',{staticClass:"not-found-text1"},[_vm._v("404")])]),_c('div',{staticClass:"not-found-container2"},[_c('h2',{staticClass:"not-found-text2"},[_vm._v(" WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND ")])])])
}]

export { render, staticRenderFns }